var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"height":"660"}},[_c('v-card-title',{staticClass:"panel-header panel-header-title-text text-color"},[_vm._v(" Library ")]),_c('v-card-text',{staticClass:"px-0"},[_c('ul',{staticClass:"library-list pt-0 mx-0 px-0 branchItem"},[_c('draggable',{attrs:{"disabled":_vm.ro,"list":_vm.items,"group":{
					revertClone: true,
					name: 'library',
					pull: 'clone',
					put: false,
				},"clone":_vm.cloned,"sort":false,"chosen-class":"chosen-item"}},_vm._l((_vm.items),function(child){return _c('lib-tree-item',{key:child.uid,attrs:{"item":child}})}),1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }